import axiosInstance from "./axiosInstance"
import axios from "axios"

export const getInformationWithAidCode = async (params) => {
    const url = params.edd === "true"
        ? `/api/service-manager/v1/form/edd/${params.aid}`
        : params.periodic === "true"
            ? `/api/service-manager/management/v1/periodic_review/get_form?access_id=${params.aid}`
            : `/api/service-manager/v1/workflow_tokens/public-get?access_id=${params.aid}`;

    return await axiosInstance.get(url, {
        headers: {
            'Content-Type': 'application/json',
        },
    });
};

export const postFingerPrintInformation = async (requestId, access_token) => {

    return await axios.post(`/api/service-manager/v1/fingerprint/create?request_id=${requestId}`,
        {
        },
        {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${access_token}`,
            },
        }
    )
}


export const sendEmail = async (email, access_token) => {

    return await axiosInstance.post(`/api/service-manager/mail/send/flow_url/email`,
        {
            "email": email
        },
        {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${access_token}`,
            },
        }
    )
}

export const sendSms = async (phoneNumber, access_token) => {

    return await axiosInstance.post(`/api/service-manager/mail/send/flow_url/sms`,
        {
            "number": phoneNumber
        },
        {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${access_token}`,
            },
        }
    )
}

export const postEddForm = async (eddForm, aid, access_token) => {

    return await axiosInstance.post(`/api/service-manager/v1/form/edd?access_id=${aid}`,
        [...eddForm]
        ,
        {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${access_token}`,
            },
        }
    )
}

export const postPeriodicReviewForm = async (periodicForm, aid, access_token) => {

    return await axiosInstance.post(`/api/service-manager/management/v1/periodic_review/upload_form?access_id=${aid}`,
        [...periodicForm]
        ,
        {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${access_token}`,
            },
        }
    )
}